module.exports = __webpack_public_path__ + "media/images/amenities_icons/karaoke-98411e96308bbeb744aebba40189931e.svg";